<template>
  <div class="note">
    <VNote :connotation="note.type || 'warning'" :headline="note.header" :icon="note.icon || ''">
      <html-text v-if="note.description" tag="span" :html="note.description" />
    </VNote>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { VNote } from '@vonage/vivid-vue';
import { NoteObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';

defineProps({
  note: { type: Object as PropType<NoteObject>, required: true },
});
</script>

<style scoped lang="scss">
.note {
  margin-bottom: 16px;
}
</style>
